import { WorkerCourse } from '../types/worker'

export const workerCourses: WorkerCourse[] = [
  {
    id: 'course-1',
    name: 'Sicurezza generale',
    firstDate: '2020-10-12',
    updateDate: '2025-10-12',
    expiryDate: '2030-10-12',
    certificateName: 'attestato_sicurezza_generale.pdf',
    expiryAlert: true,
  },
  {
    id: 'course-2',
    name: 'Primo soccorso',
    firstDate: '2021-01-01',
    updateDate: '',
    expiryDate: '2024-01-01',
    certificateName: '',
    expiryAlert: true,
  },
  {
    id: 'course-3',
    name: 'Antincendio rischio medio',
    firstDate: '2023-03-15',
    updateDate: '',
    expiryDate: '2028-03-15',
    certificateName: 'attestato_antincendio_rischio_medio.pdf',
    expiryAlert: true,
  },
]
